import _ from 'lodash';
import axios from "axios";
import { api } from '../constants/appUrl';
import {methods as sessIONstorage} from "primevue/chips";
// Importação do router foi removida pois não será mais usada para redirecionamento.

export const request = {
    methods: {
        get: 'GET',
        options: 'OPTIONS',
        post: 'POST',
        put: 'PUT',
        patch: 'PATCH',
        delete: 'DELETE',
    },
    clearParams(params){
        return _.omitBy(_.clone(params), (param) => _.isObjectLike(param));
    },
    makeRequest(url, method = this.methods.get, body = {}, params = {}, headers = {}) {

        return new Promise(async (resolve, reject) => {
            return axios({
                method: method,
                url: api + url,
                params: params,
                data: body,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
                    ...headers
                },
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error.response && error.response.status === 401) {
                    console.error('Erro 401: Token inválido ou expirado. Dando refresh na página...');
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem("user");
                    location.reload();
                }
                reject(error.response.data);
            });
        });

    },
    pagination(response, pagination){
        pagination.page = response.meta.current_page;
        pagination.per_page = response.meta.per_page;
        pagination.last_page = response.meta.last_page;
        pagination.links = response.meta.links;
        return response.data;
    },
    get(url, params = {}, headers = {}) {
        return this.makeRequest(
            url,
            this.methods.get,
            {},
            this.clearParams(params),
            headers
        );
    },
    post(url, body, params = {}, headers = {}) {
        return this.makeRequest(
            url,
            this.methods.post,
            body,
            this.clearParams(params),
            headers
        );
    },
    put(url, body, params = {}, headers = {}) {
        return this.makeRequest(
            url,
            this.methods.put,
            body,
            this.clearParams(params),
            headers
        );
    },
    delete(url, params = {}, headers = {}) {
        return this.makeRequest(
            url,
            this.methods.delete,
            {},
            this.clearParams(params),
            headers
        );
    }
}
